import React from 'react';
import Div from '../Div';
import { UatNote, UatPageShell } from './UatDocumentationPage';

export default function ThreeDSPendingPage() {
  return (
    <UatPageShell
      title="3D Secure Authentication"
      breadcrumb="3DS Pending"
      heading="3D Secure Authentication"
      subtitle="Pending GTBank MPGS sandbox credentials and test card"
    >
      <p className="cs-m0" style={{ lineHeight: 1.8 }}>
        Status: <strong style={{ color: '#ff4a17' }}>Pending GTBank MPGS sandbox credentials and test card</strong>
      </p>
      <Div style={{ marginTop: 24 }}>
        <p className="cs-m0" style={{ marginBottom: 12 }}>Supported methods expected:</p>
        <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
          <li>Mastercard SecureCode</li>
          <li>Verified by Visa</li>
        </ul>
      </Div>
      <UatNote>
        Actual 3D Secure / OTP screenshot will be captured during MPGS sandbox UAT after credentials are provided.
      </UatNote>
    </UatPageShell>
  );
}
